import { Component } from 'react'

import PartiesTab from "./PartiesTab"

class PartiesTabContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: "",
            isArchived: false,
            openModal: "",
        }
    }

    toggleTab = (tabId) => {
        this.props.navigate({ hash: this.state.tab })
        this.setState({ tab: tabId })
    }

    render() {
        return (
            <div className="overview-tab-container">
                <div className='mb-4'>
                    <strong>Exclude Archived</strong>
                    <div className="toggle-switch">
                        <input
                            type="checkbox"
                            className="toggle-switch-checkbox"
                            name="isArchived"
                            id="isArchived"
                            checked={this.state.isArchived}
                            onChange={() => this.setState({ isArchived: !this.state.isArchived })}
                        />
                        <label className="toggle-switch-label" htmlFor="isArchived">
                            <span className="toggle-switch-inner" />
                            <span className="toggle-switch-switch" />
                        </label>
                    </div>
                    <strong>Show Archived</strong>
                </div>
                <PartiesTab loading={this.props.loading} id={this.props.id} refetchQuery={this.props.refetchQuery} isArchived={this.state.isArchived} />
            </div >
        )
    }
}

export default (PartiesTabContainer)
